import React from "react";
import { Link } from "react-router-dom";

const AgencyNotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300 dark:text-base-content/30">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-base-content/80 mb-4">
            Agency Page Not Found
          </h2>
          <p className="text-gray-600 dark:text-base-content/70 mb-8">
            The agency page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/agency/dashboard"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go to Agency Dashboard
          </Link>
          <div>
            <Link
              to="/agency/login"
              className="text-blue-600 dark:text-blue-300 hover:text-blue-800 dark:hover:text-blue-200 underline"
            >
              Agency Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgencyNotFound;
